module.exports = __webpack_public_path__ + "static/media/img-06.4de5ccb9.jpg";